var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Loading',[_c('div',{staticClass:"d-flex flex-column pa-2 justify-content-center align-items-center"},[_c('Row',{staticClass:"image-row"}),_c('Row')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }